// extracted by mini-css-extract-plugin
export default {"widget_button":"WidgetButton_widget_button__J7Zpl"};